<template>
  <v-col cols="12">
    <div>
      <div style="display: flex; flex-wrap: wrap;">
        <div class="col-12 col-md-5 m-2">
          <label>Fecha de Inicio</label>
          <date-picker @dateSelected="(startP) => {
                start = startP
              }" v-model="start" :value="start"  />
        </div>
        <div class="col-12 col-md-5 m-2">
          <label>Fecha Final</label>
          <date-picker @dateSelected="(endP) => (end = endP)" v-model="end" :value="end"></date-picker>
        </div>
        <div class="col-12 col-md-2 my-2">
          <div class="d-flex align-center h-100 mt-4">
            <DxButton :width="100" class="" text="aplicar" type="default" styling-mode="contained" @click="getTopCustomersByDate()" />
          </div>
        </div>
      </div>
     
      <v-radio-group v-model="dataType" v-if="false">
          <v-radio label="Ver reporte con datos de prueba" value="00"></v-radio>
          <v-radio label="Ver reporte con datos de producción" value="01"></v-radio>
      </v-radio-group>
    </div>
    <spinner v-if="loading" />
    <div class="white" :style="{  borderRadius:'5%' }" v-else-if="loading === false && total>=1">
      <DxPieChart
        id="pie"
        :data-source="productsAndServices"
        type="doughnut"
        title="Resumen de ventas de Productos y Servicios"
        palette="Soft Pastel"
        center-template="centerTemplate"
        :inner-radius="0.65"
          resolve-label-overlapping="shift"
          size-group="piesGroup"
      >
        <DxSeries
          argument-field="ItemDescription"
          value-field="val"
        >
          <DxLabel :visible="false" format="fixedPoint">
            <DxConnector :visible="true"  />
          </DxLabel>
        </DxSeries>
        <DxExport :enabled="true" />
        <DxLegend :visible="false"
          :margin="0"
          horizontal-alignment="right"
          vertical-alignment="top"
        />
        <DxTooltip :enabled="true" :customize-tooltip="customizeTooltip">
          <DxFormat type="millions" />
        </DxTooltip>
        <template #centerTemplate>
          <template>
            <svg>
              <circle
  
                cx="100"
                cy="100"
                fill="#eee"
              />
  
              <text
                :style="{ fontSize: 18, fill: '#494949' }"
                text-anchor="middle"
                x="100"
                y="120"
              >
                <tspan x="100">Ventas total</tspan>
                <tspan :style="{ fontWeight: 600 }" x="100" dy="20px">
                $ {{ numberWithCommas( truncarDecimales(total, 2) )}}
                </tspan>
              </text>
            </svg>
          </template>
        </template>
      </DxPieChart>
    </div>
    <div v-else style="height: 415px !important" >
      <h2 style="text-align: center; top: 50%; transform: translateY(475%);">Aún no hay ventas para mostrar</h2>
    </div>
  </v-col>
</template>
<script>
import DxPieChart, {
  DxLegend,
  DxSeries,
  DxTooltip,
  DxFormat,
  DxLabel,
  DxConnector,
  DxExport,
} from "devextreme-vue/pie-chart";
import DxButton from "devextreme-vue/button";
import DatePicker from '../../components/DatePicker'
import { numberWithCommas } from "../../helpers/money";
import moment from "moment";
import spinner from "./spinner.vue";

export default {
  components: {
    DxPieChart,
    DxLegend,
    DxSeries,
    DxTooltip,
    DxFormat,
    DxLabel,
    DxConnector,
    DxExport,
    DatePicker,
    DxButton,
    spinner,
  },
  props:{
    branch:{
      type:Number,
      default: 0,
    },
    ambiente:{
      type:Number,
      default: 1,
    },
    autoLoad: {
      type: Boolean,
      default: true,
    }
  },
  data() {
    return {
      productsAndServices: [],
      total: null,
      loading: false,
      dataType: '01',
      start: moment().format("01/MM/YYYY"),
      end: moment().format("DD/MM/YYYY"),
    };
  },
  watch: {
    branch(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.getTopCustomersByDate();
      }
    }
  },
  mounted() {
    if (this.autoLoad) {
      this.getTopCustomersByDate();
    }
  },
  methods: {
    truncarDecimales(numero, decimales) {
      const factor = Math.pow(10, decimales);
      return Math.trunc(numero * factor) / factor;
    },
    numberWithCommas( value ) {
      return numberWithCommas( value );
    },
    getTopCustomers() {
      this.loading = true;
      this.$API.dashboard.getProductsServices({ dataType: this.dataType}).then((response) => {
        this.setValues(response);
        
      }).finally(() => {
        this.loading = false;
      });
    },
    getTopCustomersByDate() {
      this.loading = true;
      const params = { 
        start: new Date(this.formatDate(this.start)), 
        end: new Date(this.formatDate(this.end)), 
        ambiente: this.ambiente,
        branch: this.branch,
      }
      return this.$API.dashboard.getProductsServicesByDate(params).then((response) => {
        this.setValues(response);
      }).finally(() => {
        this.loading = false;
      });
    },
    setValues(response){
      this.productsAndServices = response.items ?? [];
      if (this.productsAndServices && this.productsAndServices.length > 0) {
        this.productsAndServices.map(e=>({
          ...e,
          val: Number(e.val),
          sold: Number(e.sold),
        }))
      }
      this.total = parseFloat(response?.total ?? 0)
    },
    formatDate(date){
      const parts = date.split('/');
      const aux = parts[0];
      parts[0] = parts[1];
      parts[1] = aux;
      return parts.join('/');
    },
    customizeTooltip(param) {
      const { argumentText, percent, value } = param;
      return {
        text: `${argumentText} - ${(percent * 100).toFixed(2)}% - $${value.toFixed(2)}`,
      };
    },
  },
};
</script>
<style>
#pie {
  height: 415px;
}
</style>
<style scoped>
.pies-container {
  margin: auto;
  width: 800px;
}

.pies-container > div {
  width: 400px;
  float: left;
  margin-top: -50px;
}

.long-title h3 {
  font-weight: 200;
  font-size: 28px;
  text-align: center;
  margin-bottom: 20px;
}
</style>
